import { type Stripe } from "@stripe/stripe-js";
import React from "react";
import Panel from "../../components/panels/panel";
import StripeSetupIntentApp from "../../Stripe/SetupIntent/app";
import CurrentPaymentMethodPanel from "./CurrentPaymentMethodContent";

interface Props {
  currentPaymentMethod: server.dto.ClientPaymentMethod
  config: server.dto.ClientPaymentSetupConfig
  stripe: Promise<Stripe>
}

const BillingDetailsPanel = (props: Props) => {
  const [paymentMethod, setPaymentMethod] = React.useState(props.currentPaymentMethod);

  if (paymentMethod != null) {
    return <Panel
      title={RESX.Payment.PaymentMethod}
      articleId={serverReference.supportArticleIds.paymentMethod}
      panelClassName="s1_related-feature-panel"
    >
      <div className="content-section">
        <CurrentPaymentMethodPanel
          paymentMethod={paymentMethod}
          onChangePaymentMethod={() => { setPaymentMethod(undefined); }} />
      </div>
    </Panel>;
  }

  return <Panel
    title={RESX.Payment.PaymentMethod}
    articleId={serverReference.supportArticleIds.paymentMethod}
    panelClassName="s1_related-feature-panel"
  >
    <div className="content-section">
      <StripeSetupIntentApp
        stripe={props.stripe}
        config={props.config}
        fetchIntentApi={async type => window.CoreApi.Stripe.CreateSetupIntent({ type }).then(r => r.data)}
      />
    </div>
  </Panel>;
};

export default BillingDetailsPanel;
